// import moment from 'moment'


// export const parseDate = (str, format = 'YYYY-MM-DD') => (str ? moment(str, format).toDate() : null)
// export const formatDate = (date, format = 'YYYY-MM-DD') => (date ? moment(date).format(format) : '')

export const durationToMinutes = (duration) => new Date(1000 * duration).toISOString().substr(11, 8).replace(/^00:/, '')
